import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {RequestService} from "../request/request.service";
import {ConstantsService} from "../constants/constants.service";
import {PermissionsService} from "../permissions/permissions.service";

@Injectable({
  providedIn: 'root'
})
export class BackgroundChecksService {
  private bgChecksList = new BehaviorSubject<any>([]);
  bgChecks = this.bgChecksList.asObservable();
  private backgroundCheckList: any;
  private pagination = {
    total: 0,
    rowsPerView: 20,
    currentPage: 1,
  };
  private totalChecks : any;
  private categorizedBackgroundChecks: any[] = [];
  mobileIdFlows = [
    ConstantsService.ID_ONE_DOC_SHORT_NAME, ConstantsService.ID_TWO_DOCS_SHORT_NAME,
    ConstantsService.ID_ONE_DOC_DVS_SHORT_NAME, ConstantsService.ID_TWO_DOCS_DVS_SHORT_NAME
  ];

  constructor(private requestService: RequestService, private alertList: AlertBannerService, private permissions: PermissionsService) {
  }

  getBackgroundChecksList(data: any) {
    return this.backgroundCheckList;
  }

  getBackgroundChecks(searchTags : any=[], pagination : any={}, sortCriteria : any={}, filters={}) {
    return this.requestService.getEnhancedBackgroundChecksList(
      searchTags, pagination?.rowsPerView, pagination?.currentPage,
      sortCriteria?.sortString, filters
    ).subscribe(response => {
        this.backgroundCheckList = this.checksVisibleForTrust1337(response['data']['background_checks']);
        this.pagination.total = response['data']['total_background_checks'];
        this.totalChecks = response['data']['total_background_checks'];
        this.categotizeCheckNamesByFlow();

        this.bgChecksList.next({
          backgroundChecks: this.backgroundCheckList,
          pagination: this.pagination,
          totalChecks: this.totalChecks,
          categorizedChecks: this.categorizedBackgroundChecks,
        })
      }, error => {
        console.log(error);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
      }]);
    });
  }

  private checksVisibleForTrust1337(checks: any[] = []) {
    return (checks || []).filter(check => {
      if (check.short_name === ConstantsService.AU_ENHANCED_PUBLIC_RECORD_CHECK_SHORT_NAME) {
        return this.permissions.isFeatureActivated('trust-1337-directorship-credit-checks');
      }
      if (check.short_name === ConstantsService.DIRECTORSHIP_CHECK_SHORT_NAME) {
        return this.permissions.isFeatureActivated('trust-1337-directorship-credit-checks');
      }
      return true;
    });
  }

  categotizeCheckNamesByFlow(){
    // reset categorizedBackgroundChecks each time the function is called
    this.categorizedBackgroundChecks = [];

    if (this.totalChecks > 0) {
      const mobileIdCheck = {
        "uid": "12345",
        "short_name": "mobile_id",
        "name": "MobileID",
        "provider_name": "RapidID",
        "config": {}
      };
      let matchedFlows: any[] = [];
      let isAdded = false;
      let insertionIndex = -1;
      let uniqueRegions = new Set<string>();
      let uniqueCategories = new Set<string>();
      this.backgroundCheckList.forEach(check => {
        if (this.mobileIdFlows.includes(check.short_name)) {
          if(!isAdded){
            // Add MobileID check in the position of ID check to maintain sort order and record the index
            insertionIndex = this.categorizedBackgroundChecks?.length;
            this.categorizedBackgroundChecks.push(mobileIdCheck);
            isAdded = true;
          }
          matchedFlows.push(check);
          // Combine unique regions and categories of each id flow
          check.config.regions.forEach(region => uniqueRegions.add(region));
          check.config.categories.forEach(category => uniqueCategories.add(category));
        } else {
          if(check.config.flows){
            check['flow_names'] = check.config.flows
          }
          this.categorizedBackgroundChecks.push(check);
        }
      });
      // If there are any id checks, add them under flow_names in MobileID
      if (matchedFlows?.length > 0 && insertionIndex != -1) {
        this.categorizedBackgroundChecks[insertionIndex]['flow_names'] = matchedFlows;
        this.categorizedBackgroundChecks[insertionIndex]['config']['regions'] = Array.from(uniqueRegions);
        this.categorizedBackgroundChecks[insertionIndex]['config']['categories'] = Array.from(uniqueCategories);
      }
    }
  }
}
